<template>
  <div>
    <div class="test-socket">
      <div class="bordered-test">
        <h5>newGameCreated</h5>
        <textarea v-model="testInput1" style="width: 100%;" /> <br />
        <button @click="$store.dispatch('betLines/listenNewGameCreated', JSON.parse(testInput1))">send event</button>
      </div>

      <div class="bordered-test">
        <h5>updateOdds</h5>
        <textarea v-model="testInput2" style="width: 100%;" /> <br />
        <button @click="$store.dispatch('betLines/setSocketMethods', JSON.parse(testInput2))">send event</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestSocketEvents',
  data() {
    return {
      testInput1: '{ "idGame" : 213213, "gameStat" : "O", "idLeague": 123 }',
      testInput2:
        '[{ "cov": "", "csv": "", "id": "10568798_1032858_ml", "e": null, "lid": "1908", "s": "F", "idscl": 0 }]',
    };
  },
};
</script>

<style scoped lang="scss">
.test-socket {
  border: 1px solid red;
  position: fixed;
  right: 20px;
  top: 50px;
  z-index: 222222;
  background: #efefef;
  padding: 10px;
  width: 400px;
  display: none;
}
.bordered-test {
  padding: 10px;
  border: 1px solid #ddd;
}
</style>
